export const GetRegistration = state => {
  if (state.repository != null) {
    return state.repository.registration.value;
  }
  return undefined;
};

export const AwaitCommunityId = state => state.repository.myCommunity.value.id;
export const AwaitCommunityTag = state => state.repository.myCommunity.value.tag;

export const AwaitCommunityMembersHasMoreToLoad = state => {
  if (state.repository.communityMembers !== undefined) {
    return state.repository.communityMembers.hasMoreToLoad;
  }
  return false;
};

export const AwaitCommunityMembersPage = state => {
  if (state.repository.communityMembers !== undefined) {
    return state.repository.communityMembers.page;
  }
  return 1;
};
